import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=2795574c&scoped=true"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"
import style0 from "./certification.vue?vue&type=style&index=0&id=2795574c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795574c",
  null
  
)

export default component.exports